// role.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { NavigationService } from './navigation.service';

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const navigationService = inject(NavigationService);
  const router = inject(Router);

  // Get current user (which includes the active role)
  const currentUser = authService.getCurrentUser();

  // If no user, redirect to login
  if (!currentUser) {
    console.warn('🚫 No user found - redirecting to login');
    router.navigate(['/login']);
    return false;
  }

  // Get the active role (this is the role currently being used)
  const activeRole = currentUser.role;

  if (!activeRole) {
    console.warn('🚫 No active role found - redirecting to login');
    router.navigate(['/login']);
    return false;
  }

  // Get the URL being accessed
  const requestedUrl = state.url;

  // Check if user's ACTIVE role is allowed to access this route
  const isAllowed = navigationService.isRouteAllowedForRole(requestedUrl, activeRole);

  if (!isAllowed) {
    console.warn('🚫 Access denied:', {
      activeRole: activeRole,
      availableRoles: currentUser.roles,
      requestedUrl: requestedUrl
    });
    
    // Store the attempted URL so we can redirect back after role change
    authService.triedUrl = requestedUrl;
    
    router.navigate(['/unauthorized']);
    return false;
  }

 
  
  return true;
};